/* istanbul ignore file */
import React from 'react';
import { useFieldHelper, TextField, FieldProps, CURRENCIES } from 'framework/ui/field';
import { getWithThousandsSeparator } from 'framework/utils';

interface CurrencyFieldProps extends FieldProps {
  currencySource: string;
  amountSource: string;
  emptyValue?: string;
  purchaseSubTotals?: Dictionary<any>;
}

const PurchaseAmountField = ({
  source,
  currencySource,
  amountSource,
  emptyValue,
  purchaseSubTotals = {},
  ...props
}: CurrencyFieldProps) => {
  const { getValue } = useFieldHelper({ source });
  const subTotals = (purchaseSubTotals[getValue()] as any) || {};
  const value = subTotals[amountSource] || 0;
  const currency = subTotals[currencySource];

  return (
    <TextField
      {...props}
      source={source}
      value={value || !emptyValue ? `${getWithThousandsSeparator(value)}${CURRENCIES[currency] || ''}` : emptyValue}
    />
  );
};

export default PurchaseAmountField;
